export default __webpack_public_path__ + "static/g2icon-febe1c1c3b802648ce5c3ef12be0a94d.svg";